'use strict';

var format = require('./format');
/*
 * function align (info)
 * Returns a new instance of the align Format which adds a `\t`
 * delimiter before the message to properly align it in the same place.
 * It was previously { align: true } in winston < 3.0.0
 */


module.exports = format(function (info) {
  info.message = "\t".concat(info.message);
  return info;
});


//////////////////
// WEBPACK FOOTER
// ./~/logform/dist/align.js
// module id = MnIB
// module chunks = 0